module.exports = __webpack_public_path__ + "static/media/cdi-no-photo-available.5c2bb1c2.png";